import {
  tutorialManager,
  TutorialSectionType,
  game,
  modes,
  TutorialMessageColors,
  MobileDetector,
  requestManager,
  corePhasesManager
} from '@powerplay/core-minigames'
import { disciplinePhasesManager } from '../../phases/DisciplinePhasesManager'
import {
  SectionNames,
  TutorialEventType,
  TutorialObjectiveIds
} from '../../types'
import { tutorialObjectives } from './TutorialObjectives'
import { tutorialUIChange } from './TutorialUIChange'
import {
  blurState,
  tutorialState
} from '@/stores'
import { tutorialCoreState } from '@powerplay/core-minigames-ui-ssm'
import { player } from '@/app/entities/athlete/player'

/**
 *  Tutorial tasky ktore maju aj logiku v sebe na ovladanie tej ktorej udalosti
 */
export class TutorialFlow {

  /** aktualny event */
  private activeEventType = TutorialEventType.awaitingEvent

  /** ci uz skoncil prvu zakrutu */
  private firstFailedStartDone = false

  /** ci uz skoncil druhu zakrutu */
  public isSecondRun = false

  /** pocitadlo excelent a perfect impulzov */
  public correctImpulses = 0

  /** ci uz sme tento pokus dali message o hode */
  private wasThrowMessage = false

  /** aktualny event */
  private finishEvent = TutorialEventType.awaitingEvent


  public setObjectivesInit(): void {

    const objectives = [
      {
        id: TutorialObjectiveIds.runUp as string,
        passed: false,
        failed: false,
        name: `tutorialTask${requestManager.disciplineID}-1`
      },
      {
        id: TutorialObjectiveIds.angle as string,
        passed: false,
        failed: false,
        name: `tutorialTask${requestManager.disciplineID}-2`
      },
      {
        id: TutorialObjectiveIds.windUp as string,
        passed: false,
        failed: false,
        name: `tutorialTask${requestManager.disciplineID}-3`
      },
      {
        id: TutorialObjectiveIds.validAttempt as string,
        passed: false,
        failed: false,
        name: `tutorialTask${requestManager.disciplineID}-4`
      }
    ]
    tutorialObjectives.setObjectives(objectives)

  }

  /**
   * Inicializacia
   */
  public init(): void {

    if (this.isSecondRun) {

      this.finishEvent = TutorialEventType.awaitingEvent
      disciplinePhasesManager.phaseStart.launchSystem()
      this.wasThrowMessage = false
      if (
        corePhasesManager.disciplineActualAttempt > 4 &&
        (corePhasesManager.disciplineActualAttempt - 2) % 3 === 0) {

        tutorialState().settings = true

      }
      return

    }
    const tutorialSections = [
      {
        name: SectionNames.mobileSidePick,
        id: 0,
        type: TutorialSectionType.storyInput,
        sectionLogicFinish: () => {

          blurState().isActive = false

        }
      },
      {
        name: SectionNames.introductionNewInstructor,
        id: 1,
        type: TutorialSectionType.storyInput,
        sectionLogicFinish: () => {

          blurState().isActive = false
          this.resetTypeWrite()

        }
      },
      {
        name: SectionNames.startSection,
        id: 2,
        type: TutorialSectionType.storyInput,
        sectionLogicFinish: () => {

          blurState().isActive = false
          this.resetTypeWrite()

        }
      },
      {
        name: SectionNames.startSectionSecond,
        id: 3,
        type: TutorialSectionType.storyInput,
        sectionLogicIntro: () => {

          tutorialState().buttons = {
            showJoystick: true,
            showMovementButtons: false
          }

        },
        sectionLogicFinish: () => {

          tutorialState().buttons = {
            showJoystick: false,
            showMovementButtons: false
          }
          this.resetTypeWrite()
          disciplinePhasesManager.phaseStart.launchSystem()

        }
      },
      {
        name: SectionNames.startSectionThird,
        id: 4,
        type: TutorialSectionType.gameEvent,
        sectionLogicIntro: () => {

          this.resetTypeWrite()

        }
      },
      {
        name: SectionNames.startSectionFourth,
        id: 5,
        type: TutorialSectionType.gameEvent
      },
      {
        name: SectionNames.startSectionFifth,
        id: 6,
        type: TutorialSectionType.gameEvent
      },
      {
        name: SectionNames.startSectionSixth,
        id: 7,
        type: TutorialSectionType.gameEvent
      },
      {
        name: SectionNames.startSectionSeventh,
        id: 8,
        type: TutorialSectionType.gameEvent
      },
      {
        name: SectionNames.startSectionEight,
        id: 9,
        type: TutorialSectionType.gameEvent,
        sectionLogicIntro: () => {

          this.resetTypeWrite()

        }
      }
    ]

    tutorialManager.setTutorialSections(tutorialSections)

    // uplne prvy tutorial
    const firstTutorialStrings = ['chooseFirstDisciplineReturnFromMinigame', 'chooseFirstDisciplineContinue']
    if (firstTutorialStrings.includes(requestManager.TUTORIAL_ID ?? '')) {

      if (MobileDetector.isMobile()) return

      tutorialManager.setActualSectionId(1)
      return

    }

    tutorialManager.setActualSectionId(2)

  }

  /**
   * Public metoda do game loopu
   */
  public update(): void {

    // this.checkInput()
    tutorialUIChange.update()
    tutorialObjectives.update()

  }

  /**
   * Kontrola inputov
   */
  public checkInput(): void {

    if (TutorialSectionType.gameEvent === tutorialManager.getActualSectionType()) {

      this.eventActionPressed()

    }

  }

  public eventActionTrigger(eventType: TutorialEventType): void {

    if (!modes.isTutorial()) return
    this.activeEventType = eventType

    if (eventType === TutorialEventType.goodFinish) {

      this.resetTypeWrite()
      game.pauseGame()
      tutorialUIChange.setMessage(true, `tutorialText${requestManager.disciplineID}-8`, TutorialMessageColors.green)
      tutorialUIChange.setAnne(true, true)
      return

    }
    if (this.wasThrowMessage) {

      this.activeEventType = TutorialEventType.awaitingEvent
      return

    }
    if (eventType === TutorialEventType.drawFoul) {

      this.finishEvent = eventType
      return

    }

    if (eventType === TutorialEventType.drawNoAngle) {

      this.wasThrowMessage = true
      this.finishEvent = eventType

    }
    if (eventType === TutorialEventType.drawNoInput) {

      this.wasThrowMessage = true
      this.finishEvent = eventType
      return

    }
    if (this.isSecondRun) {

      this.activeEventType = TutorialEventType.awaitingEvent
      return

    }

    if (eventType === TutorialEventType.drawStart) {

      const text = MobileDetector.isMobile() ?
        `tutorialText${requestManager.disciplineID}-3m` :
        `tutorialText${requestManager.disciplineID}-3`

      this.resetTypeWrite()
      game.pauseGame()
      tutorialUIChange.setMessage(true, text, undefined, undefined, true)
      tutorialUIChange.setAnne(true, false)
      tutorialState().showFinger = true
      return

    }
    if (eventType === TutorialEventType.drawSuccess) {

      if (player.wasFoul) {

        this.activeEventType = TutorialEventType.awaitingEvent
        return

      }
      this.wasThrowMessage = true
      this.finishEvent = eventType

    }

  }

  /**
   * Po prejdeni ciela
   */
  private triggerFinishEvent(): void {

    if (tutorialObjectives.isAllObjectivesPassed()) {

      this.eventActionTrigger(TutorialEventType.goodFinish)
      return

    }
    console.warn('FINISH EVENT', this.finishEvent)

    if (this.finishEvent === TutorialEventType.drawNoAngle) {

      const text = MobileDetector.isMobile() ?
        `tutorialText${requestManager.disciplineID}-5m` :
        `tutorialText${requestManager.disciplineID}-5`

      this.resetTypeWrite()
      game.pauseGame()
      tutorialUIChange.setMessage(true, text)
      tutorialUIChange.setAnne(true, true)


    }
    if (this.finishEvent === TutorialEventType.drawFoul) {

      this.resetTypeWrite()
      game.pauseGame()
      tutorialUIChange.setMessage(true, `tutorialText${requestManager.disciplineID}-6`)
      tutorialUIChange.setAnne(true, true)
      return

    }
    if (this.finishEvent === TutorialEventType.drawNoInput) {

      const text = MobileDetector.isMobile() ?
        `tutorialText${requestManager.disciplineID}-4m` :
        `tutorialText${requestManager.disciplineID}-4`

      this.resetTypeWrite()
      game.pauseGame()
      tutorialUIChange.setMessage(true, text)
      tutorialUIChange.setAnne(true, true)
      return

    }
    if (this.isSecondRun) {

      this.activeEventType = TutorialEventType.awaitingEvent
      this.finishEvent = TutorialEventType.awaitingEvent
      return

    }
    if (this.finishEvent === TutorialEventType.drawSuccess) {

      if (player.wasFoul) {

        this.finishEvent = TutorialEventType.drawFoul
        this.triggerFinishEvent()
        return

      }
      this.resetTypeWrite()
      game.pauseGame()
      tutorialUIChange.setMessage(true, `tutorialText${requestManager.disciplineID}-7`)
      tutorialUIChange.setAnne(true, true)

    }

  }

  /** Reset typewrite */
  private resetTypeWrite(): void {

    tutorialManager.setTypeWriting(true)
    tutorialCoreState().typeWriter = true

  }

  public eventActionPressed(): void {

    if (game.paused) game.resumeGame()

    tutorialState().showFinger = false
    tutorialUIChange.setMessage(false, '')
    tutorialUIChange.setAnne(false)

    if (
      [
        TutorialEventType.goodFinish
      ].includes(this.activeEventType)
    ) {

      tutorialManager.blockInputsManually()
      game.prematureFinishGame(disciplinePhasesManager.disciplinePrematureEnd)

    }
    this.activeEventType = TutorialEventType.awaitingEvent

  }

  /**
   * Po prejdeni ciela
   */
  public finishPassed(): void {

    if (!modes.isTutorial()) return
    console.log('FINISH PASSED')

    if (this.isSecondRun) {

      console.warn(tutorialObjectives.isAllObjectivesPassed())
      if (tutorialObjectives.isAllObjectivesPassed()) {

        this.eventActionTrigger(TutorialEventType.goodFinish)

      } else {

        if (corePhasesManager.disciplineActualAttempt === corePhasesManager.disciplineAttemptsCount) {

          corePhasesManager.insertNewDisciplinePhase()
          corePhasesManager.disciplineAttemptsCount += 1

        }

      }
      this.triggerFinishEvent()
      return

    }
    this.setObjectivesInit()
    this.triggerFinishEvent()
    this.isSecondRun = true


  }

}

export const tutorialFlow = new TutorialFlow()
